import React from 'react';
import { Separator } from '@wunder/ui-components';

const Divider = () => {
  return <Separator backgroundColor="bg-200" gapBottom={24} gapTop={20} />;
};

export default Divider;
